import { createSlice } from '@reduxjs/toolkit'



export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    filter: {
      code:         { enabled: true, value: null },
      name:         { enabled: true, value: '' },
      city:         { enabled: true, value: '' },
      seasons:      { enabled: true, value: [] },
      destinations: { enabled: true, value: [] },
      giata:        { enabled: true, value: '' },
      active:       { enabled: false, value: null },
      hlx:          { enabled: false, value: null },
      tzo:          { enabled: false, value: null }
    },
    pagination: {
      recordsPerPage: 25,
      actualPage: 1,
      numberOfPages: 1
    },
    sorting: {
      by: 'code',
      direction: 'ASC'
    },
    isFiltered : false,
    isSearching: false,
    result: {
      numberOfRecordsTotal: 0,
      numberOfRecords: 0,
      records: []
    }
  },
  reducers: {
    incrementByAmount: (state, action) => {
      state.value += action.payload
    },
    enableFilter: (state, action) => {
      state.filter[action.payload].enabled = true;
    },
    disableFilter: (state, action) => {
      state.filter[action.payload].enabled = false;
      state.filter[action.payload].value = null;
    },
    setFilterValue: (state, action) => {
      state.filter[action.payload.filter].value = action.payload.value;
    },

    setSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    
    setResult: (state, action) => {
      state.pagination.actualPage = 1;
      state.pagination.numberOfPages = 1;

      state.result.records = action.payload.result;
      state.result.numberOfRecords = parseInt(action.payload.result.length);
      state.result.numberOfRecordsTotal = parseInt(action.payload.numberOfRecordsTotal);
      state.isFiltered = true;

      // set sorting if provided
      if (action.payload.sorting) {
        state.sorting = action.payload.sorting;
      }

      // reset paginatiom
      state.pagination.actualPage = 1;
      state.pagination.numberOfPages = 1;
    },
    addResult: (state, action) => {
      if (action.payload) {
        action.payload.forEach(record => {
          state.result.records.push(record);
        });
        state.result.numberOfRecords += parseInt(action.payload.length);
        state.isFiltered = true;

        state.pagination.actualPage = state.pagination.actualPage + 1;
        state.pagination.numberOfPages = state.pagination.numberOfPages + 1;
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { enableFilter, disableFilter, setFilterValue, setResult, addResult, setSearching } = searchSlice.actions

export default searchSlice.reducer